import { Component, OnInit, ElementRef } from '@angular/core';
import { NavService } from '../../../services/nav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, UntypedFormGroup, Validators, FormGroup, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LibService } from '../../../services/libService';
import { TranslatorService } from 'src/app/services/translate.service';
import { MarketingNoteService } from '../../../services/marketingNote.service'

@Component({
  selector: 'app-marketing-note-settings-form',
  templateUrl: './marketing-note-settings-form.component.html',
  styleUrls: ['./marketing-note-settings-form.component.scss']
})
export class MarketingNoteSettingsFormComponent implements OnInit {

  sectionName = "marketing-note-settings"

  form: UntypedFormGroup;
  id: any;

  marketingNote: any = null;

  translationList: any = []

  languageCodeList: any = [
    {
      label: 'Italiano',
      code: 'IT'
    },
    {
      label: 'Français',
      code: 'FR'
    },
    {
      label: 'Español',
      code: 'ES'
    },
    {
      label: 'English',
      code: 'EN'
    },
  ]

  constructor(
    public navService: NavService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public libService: LibService,
    private toastr: ToastrService,
    public translate: TranslatorService,
    private router: Router,
    private marketingNoteService: MarketingNoteService,
  ) {}


  addTranslation(values: any): FormGroup {

    let translation: FormGroup = this.fb.group(values);

    return translation

  }


  determinesValue = (value: any, type: any) => {

    let valueStructure: any = null
    let tmpValue = [null, undefined, []].includes(value) ? 0 : value

    switch (type) {
      case 'boolean':
        valueStructure = parseInt(tmpValue) !== 0
        break;
      case 'number':
        valueStructure = parseInt(tmpValue)
        break;
      case 'string':
        valueStructure = value
        break;
    }

    return valueStructure
  }


  get translations(): FormArray {
    return <FormArray>this.form.get('translations');
  }

  update() {
    this.libService.lockPage('');
    console.log(this.form.value)


    this.marketingNoteService.createSettings(this.form.value).subscribe((response: any) => {
      //console.log(response)
      
      this.toastr.success(
        'ok', this.translate.instant('LABEL.Info'));

      this.id = response.id
      this.form?.get('id')?.setValue(this.id)
      this.form?.get('TranslationGroupId')?.setValue(response.TranslationGroupId)
      this.form?.get('code')?.setValue(response.code)
      this.router.navigate([`/settings/${this.sectionName}/`, this.id]);
      
      this.libService.unlockPage();
    })
    

  }

  back() {
    this.router.navigate([`settings/${this.sectionName}/`]);
  }

  initTranslations() {

    this.languageCodeList.forEach((lang: any) => {
      let currentTranslation = this.translationList.find((translation: any) => translation.languageCode == lang.code)
      let structure: any = {
        id: [null],
        languageCode: [lang.code, Validators.required],
        text: [null, Validators.required],
      }

      if (currentTranslation?.id) structure.id = currentTranslation?.id
      if (currentTranslation?.languageCode) structure.languageCode = currentTranslation?.languageCode
      if (currentTranslation?.text) structure.text = currentTranslation?.text

      this.translations.push(this.addTranslation(structure))
    })
  }

  ngOnInit(): void {
    this.libService.lockPage('');
    this.id = this.route.snapshot.paramMap.get('id');

    // Creazione Form
    this.form = this.fb.group({
      id: [],
      label: [null, Validators.required],
      code: [null, Validators.required],
      disabled: [false],
      subject: [false],
      request: [false],
      translations: this.fb.array([])
    })

    if (['0', 0, null, undefined].includes(this.id)) {
      this.initTranslations()
      this.libService.unlockPage();
    } else {
      this.initForm()
    }

  }

  initForm() {
    this.marketingNoteService.settings(this.id).subscribe((response: any) => {
      if (response) {
        this.marketingNote = response
        this.translationList = this.marketingNote?.translationGroup?.translations

        this.form?.get('id')?.setValue(this.id)
        this.form?.get('label')?.setValue(this.marketingNote?.label)
        this.form?.get('code')?.setValue(this.marketingNote?.code)
        this.form?.get('TranslationGroupId')?.setValue(this.marketingNote?.translationGroup?.id)
        this.form?.get('disabled')?.setValue(this.marketingNote?.disabled)
        this.form?.get('subject')?.setValue(this.marketingNote?.subject)
        this.form?.get('request')?.setValue(this.marketingNote?.request)

        this.initTranslations()
        console.log(this.form)
        this.libService.unlockPage();
      } else {
        this.initTranslations()
        this.libService.unlockPage();
      }
    })
  }


  setCode() {
    if ([undefined, null, 0, '0'].includes(this.id)) {
      let label = this.form?.get('label')?.value
      let code = `marketing_notes_${this.snakeCase(label)}`
      this.form?.get('code')?.setValue(code)
    }
  }

  snakeCase(string: any) {
    return string.replace(/\W+/g, " ")
      .split(/ |\B(?=[A-Z])/)
      .map((word: any) => word.toLowerCase())
      .join('_');
  };

}